import 'containers/common/Detail.css';
import BuildingGradeList from "containers/property/BuildingGradeList";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";





export default class BuildingGradeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true            
        };
     
       
    }
    

    async componentDidMount() {
        console.log("In BuildingGradeModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    


    renderComponent() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleBuildingGradeModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Building Grades</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
              

                        <BuildingGradeList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        buildingGradeSourceOptions={this.props.buildingGradeSourceOptions}
                        buildingGradeOptions={this.props.buildingGradeOptions}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="BuildingGradeEdit">
                {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            </div>
        );
    }
}
